// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AccountFormController from "./account_form_controller"
application.register("account-form", AccountFormController)

import AddressStateController from "./address_state_controller"
application.register("address-state", AddressStateController)

import AppController from "./app_controller"
application.register("app", AppController)

import ChangeRequestFormController from "./change_request_form_controller"
application.register("change-request-form", ChangeRequestFormController)

import ClaimContractSummaryController from "./claim_contract_summary_controller"
application.register("claim-contract-summary", ClaimContractSummaryController)

import ConfirmationModalController from "./confirmation_modal_controller"
application.register("confirmation-modal", ConfirmationModalController)

import ConstraintValueController from "./constraint_value_controller"
application.register("constraint-value", ConstraintValueController)

import ContractFormController from "./contract_form_controller"
application.register("contract-form", ContractFormController)

import CopyClipboardController from "./copy_clipboard_controller"
application.register("copy-clipboard", CopyClipboardController)

import CurrencyInputController from "./currency_input_controller"
application.register("currency-input", CurrencyInputController)

import DialogController from "./dialog_controller"
application.register("dialog", DialogController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import DueDateController from "./due_date_controller"
application.register("due-date", DueDateController)

import DynamicFieldsController from "./dynamic_fields_controller"
application.register("dynamic-fields", DynamicFieldsController)

import ExpandableResultController from "./expandable_result_controller"
application.register("expandable-result", ExpandableResultController)

import FacetedSearchController from "./faceted_search_controller"
application.register("faceted-search", FacetedSearchController)

import FormController from "./form_controller"
application.register("form", FormController)

import InlineCustomerController from "./inline_customer_controller"
application.register("inline-customer", InlineCustomerController)

import InvoiceTotalsController from "./invoice_totals_controller"
application.register("invoice-totals", InvoiceTotalsController)

import NestedFormFieldsController from "./nested_form_fields_controller"
application.register("nested-form-fields", NestedFormFieldsController)

import NotificationsController from "./notifications_controller"
application.register("notifications", NotificationsController)

import PartyFormController from "./party_form_controller"
application.register("party-form", PartyFormController)

import PasswordInputController from "./password_input_controller"
application.register("password-input", PasswordInputController)

import PhoneFormController from "./phone_form_controller"
application.register("phone-form", PhoneFormController)

import PhoneInputController from "./phone_input_controller"
application.register("phone-input", PhoneInputController)

import RemoveOnDisconnectController from "./remove_on_disconnect_controller"
application.register("remove-on-disconnect", RemoveOnDisconnectController)

import SendQueueController from "./send_queue_controller"
application.register("send-queue", SendQueueController)

import TabSelectController from "./tab_select_controller"
application.register("tab-select", TabSelectController)

import TableController from "./table_controller"
application.register("table", TableController)

import TablePaginatorController from "./table_paginator_controller"
application.register("table-paginator", TablePaginatorController)

import TableSortController from "./table_sort_controller"
application.register("table-sort", TableSortController)

import ToastController from "./toast_controller"
application.register("toast", ToastController)

import TomSelectController from "./tom_select_controller"
application.register("tom-select", TomSelectController)

import UserRoleFormController from "./user_role_form_controller"
application.register("user-role-form", UserRoleFormController)
